import { NgbDateStruct } from '@cmps/ng-bootstrap';

export type TdCompliancePeriodType = 'MTD' | 'QTD' | 'YTD';

export interface TdComplianceResult {
    resultSet: string;
    params: string;
    periods: string;
}

export interface TdComplianceUser {
    userId: number;
    userName: string;
}

export enum TdComplianceReportPopulationType {
    SuperGroup = '1',
    PeerGroup = '2',
    Individual = '3',
}

export interface TdComplianceReportSelectionParams {
    populationType: TdComplianceReportPopulationType;
    populationID: TdComplianceUser | string;
    defaultPopulationID: TdComplianceUser | string;
    date: NgbDateStruct;
    invalidUser: boolean;
    invalidDate: boolean;
    pendingData: boolean;
    noData: boolean;
}

export interface TdComplianceReportResultParams {
    requestUserID: string;
    date: string;
    populationType: string;
    populationID: string;
    dateRequest: string;
}

export interface TdComplianceResultRow {
    category: string;
    objective: number;
    passRate: number;
    passed: number;
    periodType: TdCompliancePeriodType;
    question: string;
    scored: number;
}

export interface TdComplianceQuestionResult {
    periodType: TdCompliancePeriodType;
    passRate: number | string;
    passed: number | string;
    scored: number | string;
}

export interface TdComplianceQuestion {
    question: string;
    objective: number;
    results: TdComplianceQuestionResult[];
}

export interface TdComplianceProcessedResult {
    category: string;
    summary: TdComplianceQuestionResult[];
    questions: TdComplianceQuestion[];
}

export interface TdComplianceSort {
    [key: string]: {
        hasSort: boolean;
        isAsc: boolean;
    };
}
